import { Controller } from "@hotwired/stimulus"
import BSN from "bootstrap.native/dist/bootstrap-native-v4-esm.min.js"

export default class extends Controller {
  initialize() {
    this.listeners = {
      updateURL: this.updateURL.bind(this),
      updateSearchResults: this.updateSearchResults.bind(this),
      ajaxError: this.ajaxError.bind(this)
    }
  }

  connect () {
    this.element.addEventListener("ajax:beforeSend", this.listeners.updateURL)
    this.element.addEventListener("ajax:success", this.listeners.updateSearchResults)
    this.element.addEventListener("ajax:error", this.listeners.ajaxError)
  }

  disconnect () {
    this.element.removeEventListener("ajax:beforeSend", this.listeners.updateURL)
    this.element.removeEventListener("ajax:success", this.listeners.updateSearchResults)
    this.element.removeEventListener("ajax:error", this.listeners.ajaxError)
  }

  updateURL(event) {
    const [_xhr, options] = event.detail
    history.replaceState({}, "", options.url)
    document.querySelector("#videos").classList.add("is--loading")
  }

  updateSearchResults(event) {
    const [data, _status, _xhr] = event.detail
    const targetNode = data.querySelector("#videos")
    document.querySelector("#videos").replaceWith(targetNode)

    const headerCountNode = data.querySelector("#header-count-display")
    if (!headerCountNode) { return }

    document.querySelector("#header-count-display").replaceWith(headerCountNode)
    BSN.initCallback(document.body)
  }

  ajaxError(event) { console.log(event) }
}
